import { useEffect, useRef, useState } from "react";
import Chart from "react-apexcharts";
import { FaInfinity } from "react-icons/fa";
import { useSelector } from "react-redux";

const ProjectOverviewDonutChart = ({
	id,
	typeoptin,
	allowanceValue,
	allowanceCurrentValue,
	paddingValue = true,
	allowanceExtensionValue,
	allowance_unite = "GB",
}) => {
	const chartRef = useRef(null); // Reference to the chart container
	const [iconSize, setIconSize] = useState(24);
	let buName = useSelector((state) => state.auth.user?.business_units[0]?.name);
	console.log(allowanceValue === "UNLIMITED" || allowanceValue == "Unlimited");

	const allowanceNum = allowanceValue;
	const allowanceCurrentNum = parseFloat(allowanceCurrentValue) || 0;
	const usagePercentage = ((allowanceCurrentNum / allowanceNum) * 100).toFixed(2);
	const allowanceExtensionNum = Number(allowanceExtensionValue);
	const showExtension = Number.isFinite(allowanceExtensionNum) && allowanceExtensionNum > 0;
	useEffect(() => {
		if (chartRef.current) {
			const height = chartRef.current.offsetHeight;
			setIconSize(Math.max(height * 0.15, 24)); // 15% of the height, minimum size of 24px
		}
	}, []);
	const options = {
		chart: {
			type: "donut",
			height: 270, // Base height for large screens
		},
		labels: ["Allowance current", "Remaining"],
		colors: ["#0E9F6E", "#1B204C"],
		plotOptions: {
			pie: {
				donut: {
					size: "65%", // Default donut size
					labels: {
						show: true,
						value: {
							formatter: (val) => {
								return `${parseFloat(val).toFixed(2)}%`;
							},
						},
						total: {
							show: true,
							label:
								allowanceValue === "UNLIMITED" || allowanceValue == "Unlimited"
									? ""
									: "Allowance usage",
							formatter: () => {
								if (allowanceValue === "UNLIMITED" || allowanceValue == "Unlimited") {
									return "";
								} else {
									return `${usagePercentage} %`;
								}
							},
						},
					},
				},
				expandOnClick: false,
			},
		},
		stroke: {
			width: 0.5, // Reduce stroke width for a smaller border
			colors: ["transparent"], // Set to transparent for no visible gap
		},
		tooltip: {
			theme: "dark",
			enabled: typeoptin !== "OPT_OUT", // Disable tooltip if typeoptin is "OPT_OUT"
			y: {
				formatter: (val) => `${val.toFixed(2)} %`, // Format tooltip values
			},
			custom: ({
				series,
				seriesIndex,
				w,
			}) => `<div style="background:#272B49 ; color: #FFFFFF; padding: 8px; border-radius: 6px;">
                  <span class="font-semibold text-base leading-normal tracking-normal" style="font-family: 'Segoe UI', sans-serif; color:#9CA3AF"  >${w.globals.labels[seriesIndex]}:</span>  <span  class="font-bold text-sm leading-none tracking-normal" style="font-family: 'Segoe UI', sans-serif;" > ${series[seriesIndex]}%</span>
                </div>`,
		},
		dataLabels: {
			enabled: false,
		},
		legend: {
			position: "bottom",
			horizontalAlign: "center",
			labels: {
				colors: ["#ffffff"],
			},
		},
	};

	const series =
		typeoptin === "OPT_OUT" || allowanceValue === "UNLIMITED" || allowanceValue == "Unlimited"
			? [100]
			: [parseFloat(usagePercentage), 100 - parseFloat(usagePercentage)];

	return (
		<div key={id} className="relative">
			<div className="relative" ref={chartRef}>
				<div style={paddingValue ? { padding: "10px" } : { padding: "0px" }}></div>

				<div style={{ height: "270px" }}>
					<Chart options={options} series={series} type="donut" height={270} />{" "}
					{(allowanceValue === "UNLIMITED" || allowanceValue == "Unlimited") && (
						<div className="absolute inset-0 flex items-center justify-center">
							<FaInfinity style={{ fontSize: `${iconSize}px` }} className="text-gray-300" />
						</div>
					)}
				</div>
			</div>

			<div className="col-span-2 rounded-2xl bg-blue-gray bg-opacity-20 p-4">
				<div className="mb-2 flex justify-between">
					<span className="font-normal text-sm text-white leading-tight">Plan</span>
					<span className="me-2 rounded bg-blue-900 px-2.5 py-0.5 font-medium text-blue-300 text-xs">
						{`${allowanceNum} ${allowance_unite}`}
					</span>
				</div>
				{showExtension && (
					<div className="mb-2 flex justify-between">
						<span className="font-normal text-sm text-white leading-tight">Extension</span>
						<span className="me-2 rounded bg-gray-600 px-2.5 py-0.5 font-medium text-gray-300 text-xs">
							{`${allowanceExtensionNum} GB`}
						</span>
					</div>
				)}
				<div className="mb-2 flex justify-between">
					<span className="font-normal text-sm text-white leading-tight">Usage</span>
					<span className="me-2 rounded bg-green-900 px-2.5 py-0.5 font-medium text-green-300 text-xs">
						{`${allowanceCurrentNum} GB`}
					</span>
				</div>
			</div>
		</div>
	);
};

export default ProjectOverviewDonutChart;
